module.exports = __webpack_public_path__ + "static/poster-intro-229487248e61482e3f13c4aacbe9eca1.jpg";